import React from 'react'
import { Placeholder, Card } from 'semantic-ui-react'

const PlaceHolderSingleLine = (props) => {
    let repratPlaceholder = []
    if (props.repeat) {
        for (let i = 0; i < props.repeat; i++) {
            repratPlaceholder.push(
                <div className="pad_10 bg-white" key={i} style={{ margin: "0 0 10px 0" }}>
                    <Placeholder>
                        <Placeholder.Header >
                            <Placeholder.Line />
                            <Placeholder.Line />
                        </Placeholder.Header>
                    </Placeholder>
                </div>
            )
        }
    } else {
        repratPlaceholder = <div className="pad_10 bg-white" style={{ margin: "0 0 10px 0" }}>
            <Placeholder>
                <Placeholder.Header >
                    <Placeholder.Line />
                    <Placeholder.Line />
                </Placeholder.Header>
            </Placeholder>
        </div>;
    }
    return repratPlaceholder;
}

export default PlaceHolderSingleLine